import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { apiRequest } from "../api/apiClient.js";
import type { GroupDTO, MemberDTO } from "../api/types.js";

export const membersQueryKey = (search: string) => ["members", search] as const;

/**
 * Die Personen im Mandanten. Alle Module brauchen sie — für Freigaben, Einladungen und
 * Unterhaltungen —, deshalb liegt der Hook in `common`.
 */
export function useMembers(search: string, enabled = true): UseQueryResult<MemberDTO[], Error> {
  return useQuery({
    queryKey: membersQueryKey(search),
    queryFn: () =>
      apiRequest<MemberDTO[]>(`/members${search ? `?search=${encodeURIComponent(search)}` : ""}`),
    enabled,
    staleTime: 60_000,
  });
}

export function useGroups(enabled = true): UseQueryResult<GroupDTO[], Error> {
  return useQuery({
    queryKey: ["groups"],
    queryFn: () => apiRequest<GroupDTO[]>("/groups"),
    enabled,
    staleTime: 60_000,
  });
}
